.loginWrap {
  min-height: 100vh;
  align-items: center;
  background-image: url("/images/login/login_bg.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  padding: 1.25rem;
  position: relative;
  background-attachment: fixed;
}

.loginWrap::before {
  background: rgb(24 24 26 / 30%);
  content: "";
  inset: 0;
  position: absolute;
}

.loginBody {
  background: var(--pm-white);
  border-radius: 1.25rem;
  display: flex;
  flex-direction: column;
  max-width: 25rem;
  overflow-y: auto;
  padding: 1.625rem 1rem 1rem;
  position: relative;
  width: 100%;
  z-index: 1;
}

.loginHeader {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-height: 1.75rem;
  margin-bottom: 2.5rem;
}

.loginHeaderLogo {
  align-items: center;
  display: flex;
  justify-content: center;
}

.loginHeaderLogo svg {
  display: block;
  height: auto;
  max-width: 9.75rem;
  width: 100%;
}

.loginBrandImage {
  border-radius: 0.375rem;
  max-height: 3rem;
  max-width: 13.75rem;
  width: auto;
}

.loginBusinessTitle {
  color: var(--pm-grey1);
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25rem;
  text-align: center;
}

.loginBusinessSubtitle {
  color: var(--pm-grey5);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  text-align: center;
}

.loginContent {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 1rem;
}

.loginRouteContent {
  display: flex;
  flex-direction: column;
}

.loginBodyAlert {
  margin-bottom: 1rem;
}

.loginAlertLink {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.125rem;
}

.loginRouteContent :global(#page-header),
.loginContent :global(#page-header) {
  justify-content: center;
  margin-bottom: 2.5rem;
  position: relative;
}

.loginRouteContent :global(#page-header) h1,
.loginContent :global(#page-header) h1 {
  color: var(--pm-grey1);
  font-size: 1.625rem;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin: 0;
  text-align: center;
}

.loginInlineLink {
  color: var(--pm-blue);
  cursor: default;
  font-weight: 500;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.125rem;
}

.loginSubtitle {
  color: var(--pm-grey5);
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: -0.03em;
  line-height: 1.5rem;
  margin: -1.75rem 0 2.5rem;
  text-align: center;
}

.loginActionLink {
  color: var(--pm-blue);
  cursor: pointer;
  font-weight: 500;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.125rem;
}

.loginBackButton {
  align-items: center;
  background: transparent;
  border: 1.25px solid var(--pm-grey10);
  border-radius: 0.625rem;
  color: var(--pm-blue);
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  height: 28px;
  justify-content: center;
  line-height: 1;
  margin-bottom: 0.25rem;
  padding: 0;
  width: 28px;
  position: absolute;
  left: 1rem;
  top: 1rem;
}

.loginBackButton:hover {
  background: rgb(33 112 247 / 6%);
}

.loginSocialButtons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.loginSocialGroup {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.loginSocialButton:global(.MuiButton-root) {
  border: 1.5px solid var(--pm-border) !important;
  border-radius: 0.625rem !important;
  color: var(--pm-grey1) !important;
  font-size: 1rem !important;
  font-weight: 500 !important;
  height: 3rem !important;
  letter-spacing: -0.03em !important;
  margin: 0 !important;
  min-height: 3rem !important;
  padding: 0.75rem 2.5rem !important;
  position: relative !important;
  text-transform: none !important;
  gap: 0.625rem;
}

.loginSocialButton:global(.MuiButton-root):hover {
  background: rgb(33 112 247 / 6%) !important;
}

.loginButtonLogo {
  position: static !important;
  height: 20px;
  width: 20px;
}

.loginOptionButtonGroup {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  width: 100%;
}

.loginOptionButtonHelper {
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.02438rem;
  margin: 0;
  width: 100%;
}

.loginOptionButtonHelperError {
  color: var(--pm-red);
}

.loginDivider {
  align-items: center;
  display: flex;
  gap: 1.4375rem;
}

.loginDividerLine {
  background: var(--pm-grey10);
  flex: 1 1 auto;
  height: 1px;
}

.loginDividerLabel {
  color: var(--pm-grey6);
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: -0.03em;
  line-height: 1.25rem;
}

.loginForm {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.loginForm :global([class*="pmEdit"]) {
  margin: 0;
}

.loginForm :global(.MuiFormControl-root) {
  margin: 0;
}

.loginPasswordHelper {
  color: var(--pm-grey6);
  font-size: 0.8125rem;
  line-height: 1.25rem;
  margin: -0.5rem 0 0.5rem;
}

.loginPrimaryButton:global(.MuiButton-root) {
  background: var(--pm-blue) !important;
  border: 1px solid var(--pm-blue) !important;
  border-radius: 0.625rem !important;
  color: var(--pm-text-filled-button) !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  height: 2.125rem !important;
  letter-spacing: -0.03em !important;
  margin: 0 !important;
  min-height: 2.125rem !important;
  text-transform: none !important;
}

.loginPrimaryButton:global(.MuiButton-root):hover {
  background: var(--pm-blue-strong) !important;
  border-color: var(--pm-blue-strong) !important;
}

.loginAuxButton:global(.MuiButton-root) {
  color: var(--pm-blue);
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: -0.03em;
  line-height: 1.25rem;
  margin: 1rem 0 0;
  min-height: auto;
  padding: 0;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-transform: none;
  text-underline-offset: 0.125rem;
}

.signUpButton:global(.MuiButton-root),
.linkAccountsButton:global(.MuiButton-root) {
  margin-top: 1rem !important;
}

.loginFooter {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.loginLegalCopy {
  color: var(--pm-grey7-polars);
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: -0.03em;
  line-height: 1.25rem;
  margin: 0;
  text-align: center;
}

.loginParagraph {
  color: var(--pm-grey5);
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: -0.03em;
  line-height: 1.5rem;
  margin: 0;
}

.loginRoleList {
  margin: 0;
}

.loginRoleButton {
  background: transparent;
  border-color: var(--pm-grey10);
  border-style: solid;
  border-width: 1px;
  gap: 0.75rem;
  transition: background-color 0.2s ease;
}

.loginRoleButton:hover {
  background: rgb(33 112 247 / 6%);
}

.loginRoleArrow {
  flex-shrink: 0;
  height: 19px;
  width: 18px;
}

:global(.dark) .loginBody,
:global(.theme-dark1) .loginBody {
  background: var(--D3, #1e1e22);
  border-top: 1px solid var(--D4, #26262b);
}

:global(.dark) .loginBusinessTitle,
:global(.theme-dark1) .loginBusinessTitle {
  color: var(--D16, #ededef);
}

:global(.dark) .loginBusinessSubtitle,
:global(.theme-dark1) .loginBusinessSubtitle,
:global(.dark) .loginParagraph,
:global(.theme-dark1) .loginParagraph,
:global(.dark) .loginSubtitle,
:global(.theme-dark1) .loginSubtitle,
:global(.dark) .loginPasswordHelper,
:global(.theme-dark1) .loginPasswordHelper {
  color: var(--D11, #898994);
}

:global(.dark) .loginInlineLink,
:global(.theme-dark1) .loginInlineLink,
:global(.dark) .loginActionLink,
:global(.theme-dark1) .loginActionLink,
:global(.dark) .loginAuxButton:global(.MuiButton-root),
:global(.theme-dark1) .loginAuxButton:global(.MuiButton-root) {
  color: var(--pm-blue-lighter);
}

:global(.dark) .loginSocialButton:global(.MuiButton-root),
:global(.theme-dark1) .loginSocialButton:global(.MuiButton-root) {
  background: var(--D4, #26262b) !important;
  border-color: var(--D4, #26262b) !important;
  border-top-color: var(--D6, #323239) !important;
  color: var(--D13, #bfbfc4) !important;
}

:global(#root) :global(.dark) .loginSocialButton:global(.MuiButton-root):hover,
:global(.theme-dark1)
  :global(#root)
  .loginSocialButton:global(.MuiButton-root):hover {
  background-color: var(--D6) !important;
  border-top-color: var(--D7) !important;
}

:global(.dark) .loginDividerLine,
:global(.theme-dark1) .loginDividerLine {
  background: var(--D7, #3f3f46);
}

:global(.dark) .loginDividerLabel,
:global(.theme-dark1) .loginDividerLabel,
:global(.dark) .loginLegalCopy,
:global(.theme-dark1) .loginLegalCopy {
  color: var(--D10, #6f6f7b);
}

:global(.dark) .loginBackButton,
:global(.theme-dark1) .loginBackButton {
  border-color: var(--D7, #3f3f46);
  color: var(--pm-blue-lighter);
}

:global(.dark) .loginPrimaryButton:global(.MuiButton-root),
:global(.theme-dark1) .loginPrimaryButton:global(.MuiButton-root) {
  background: var(--pm-blue) !important;
  border-color: var(--pm-blue) !important;
}

:global(.dark) .loginRoleButton,
:global(.theme-dark1) .loginRoleButton {
  border-color: var(--D7, #3f3f46);
}

:global(.dark) .loginRoleButton:hover,
:global(.theme-dark1) .loginRoleButton:hover {
  background: rgb(61 138 255 / 12%);
}
